import HardBreak from '@tiptap/extension-hard-break';
import type { Editor } from '@tiptap/react';

const isInsideTableCell = (editor: Editor): boolean => {
  const { state } = editor;
  const { $from } = state.selection;

  for (let depth = $from.depth; depth > 0; depth -= 1) {
    const node = $from.node(depth);

    if (node.type?.name === 'tableCell' || node.type?.name === 'tableHeader') {
      return true;
    }
  }

  return false;
};

const CustomHardBreak = HardBreak.extend({
  addKeyboardShortcuts() {
    const parentShortcuts = this.parent?.() ?? {};

    return {
      ...parentShortcuts,
      Enter: (props) => {
        if (!this.editor.isEditable) {
          return false;
        }

        if (!isInsideTableCell(this.editor)) {
          const fallback = parentShortcuts.Enter;

          return typeof fallback === 'function' ? fallback(props) : false;
        }

        return this.editor.chain().focus().setHardBreak().run();
      },
    };
  },
});

export default CustomHardBreak;
